import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import api from '../api';
import { toast } from 'react-toastify';
import { useTheme } from '../context/ThemeProvider';
import { toastStyles } from '../styles/styles';
const useCreate = (queryKey, apiCall, defaultSuccessMessage = 'Item created successfully', defaultErrorMessage = 'Item creation failed') => {
    const queryClient = useQueryClient();
    const [createDialogOpen, setCreateDialogOpen] = useState(false);
    const { theme } = useTheme();

    const mutation = useMutation({
        mutationFn: async (data) => {
            const response = await apiCall(data);
            return response.data;
        },
        onSuccess: (data) => {
            toast.success(data?.message || defaultSuccessMessage, { ...toastStyles, theme: theme });
            queryClient.invalidateQueries([queryKey]);
            handleCloseAll();
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message || defaultErrorMessage, { ...toastStyles, theme: theme });
            handleCloseAll();
        }
    });
    // Handler to open edit form
    const handleCreate = (data) => {
        if (data) {
            mutation.mutate(data);
        }
    };

    const handleCloseAll = () => {
        setCreateDialogOpen(false);
        mutation.reset();
    };

    return {
        create: handleCreate,
        isLoading: mutation.isLoading,
        isError: mutation.isError,
        error: mutation.error,
        isSuccess: mutation.isSuccess,
        status: mutation.status,
        createDialogProps: {
            isOpen: createDialogOpen,
            onOpen: () => setCreateDialogOpen(true),
            onClose: () => setCreateDialogOpen(false),
            setIsOpen: setCreateDialogOpen
        }
    };
};

export default useCreate;
